import { applyMiddleware, createStore, compose } from 'redux';
import { fromJS } from 'immutable';
import { combineReducers } from 'redux-immutable';
import createSagaMiddleware from 'redux-saga';

import { eth0AtSeinfeld} from './library/constants';
import treeReducer from './controller/reducer';
import watchAll from './controller/sagas';

const sagaMiddleware = createSagaMiddleware();

const createReducer = (injectedReducers) => {
  return combineReducers({
    tree: treeReducer,
    ...injectedReducers,
  });
}

export default function configureStore(initialState = {}) {
  const middlewares = [
    sagaMiddleware,
  ];

  const enhancers = [
    applyMiddleware(...middlewares),
  ];

  const isSeinfeld = () => {
    return document.getElementById('prodScript') &&
    document.getElementById('prodScript').getAttribute('host') &&
    document.getElementById('prodScript').getAttribute('host') === `//${eth0AtSeinfeld}:5000` &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  }

  const isStage = () => {
    return document.getElementById('prodScript') &&
    document.getElementById('prodScript').getAttribute('host') &&
    document.getElementById('prodScript').getAttribute('host') === '//stage.geni.com' &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  }

  const composeEnhancers =

    (
      process.env.NODE_ENV !== 'production' &&
      typeof window === 'object' &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    )

      ||

    isSeinfeld()

      ||

    isStage()

      ?

    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__

      :

    compose;

  const store = createStore(
    createReducer(),
    fromJS(initialState),
    composeEnhancers(...enhancers)
  );

  sagaMiddleware.run(watchAll);

  window.store = store; // window.store.dispatch({type:"Tree/SET_NODE_DEFAULTS", obj: {nodeWidth:60, nodeHeight:30}})

  return store;
}
